import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Button } from '@/shared/uikitV2/Button';

export const FieldButton = styled(Button)`
  align-self: flex-start;

  &&& {
    padding: 0;
    height: 24px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${COLORS.systemSky200};
  }
`;
